import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-stack" }, [
  /*#__PURE__*/_createVNode("h3", { class: "m-0 text-white fw-bolder fs-3" }, "Porfolio")
], -1)
const _hoisted_3 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "fw-bold fs-7" }, "You Balance", -1)
const _hoisted_5 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_6 = {
  class: "shadow-xs card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1 bg-white",
  style: {"margin-top":"-100px"}
}
const _hoisted_7 = { class: "d-flex align-items-center mb-7" }
const _hoisted_8 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_9 = { class: "symbol-label bg-lighten" }
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_12 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_13 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
}, "Name", -1)
const _hoisted_14 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "fw-bolder fs-5 text-gray-800 pe-1" }
const _hoisted_17 = { class: "d-flex align-items-center mb-7" }
const _hoisted_18 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_19 = { class: "symbol-label bg-lighten" }
const _hoisted_20 = { class: "svg-icon svg-icon-1" }
const _hoisted_21 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "mb-1 pe-3 flex-grow-1" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
  }, "Investment")
], -1)
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "fw-bolder fs-5 text-gray-800 pe-1" }
const _hoisted_25 = { class: "d-flex align-items-center mb-7" }
const _hoisted_26 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_27 = { class: "symbol-label bg-lighten" }
const _hoisted_28 = { class: "svg-icon svg-icon-1" }
const _hoisted_29 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "mb-1 pe-3 flex-grow-1" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
  }, "Interest Earned")
], -1)
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = { class: "fw-bolder fs-5 text-gray-800 pe-1" }
const _hoisted_33 = { class: "d-flex align-items-center mb-7" }
const _hoisted_34 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_35 = { class: "symbol-label bg-lighten" }
const _hoisted_36 = { class: "svg-icon svg-icon-1" }
const _hoisted_37 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "mb-1 pe-3 flex-grow-1" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
  }, "Total")
], -1)
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = { class: "fw-bolder fs-5 text-gray-800 pe-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [`bg-${_ctx.widgetColor}`, "px-9 pt-7 card-rounded h-275px w-100"]
      }, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.eccdashboarddata.balance).toFixed(2))) + " PhP ", 1)
        ])
      ], 2),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.user.usid), 1)
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, _toDisplayString(_ctx.user.fname) + " " + _toDisplayString(_ctx.user.lname), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("span", _hoisted_19, [
              _createVNode("span", _hoisted_20, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Money.svg" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.eccdashboarddata.investmentAmount).toFixed(2))) + " PhP ", 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("span", _hoisted_27, [
              _createVNode("span", _hoisted_28, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Chart-line1.svg" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.eccdashboarddata.totalinterestearned).toFixed(2))) + " PhP ", 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("span", _hoisted_35, [
              _createVNode("span", _hoisted_36, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Wallet.svg" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.eccdashboarddata.totalearned).toFixed(2))) + " PhP ", 1)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}